import { EligibilityStatus, GetEligibilityResponse } from '../containers/Auth/types';
import httpClient from './HttpClient';

class LicensingClient {
    public static getInstance(): LicensingClient {
        if (!LicensingClient.instance) {
            LicensingClient.instance = new LicensingClient();
        }
        return LicensingClient.instance;
    }

    private static instance: LicensingClient;
    private static url = '/licensing';

    private constructor() {}

    public async getEligibility(): Promise<EligibilityStatus> {
        const response = await httpClient.get<EligibilityStatus>(`${LicensingClient.url}/eligibility`);
        return response.data;
    }

    // For sysAdmin only: Get plan eligibility by orgId of the sys admin
    public async getPlanEligibility(): Promise<GetEligibilityResponse> {
        const response = await httpClient.get<GetEligibilityResponse>(`${LicensingClient.url}/planeligibility`);
        return response.data;
    }
}

const licensingClient = LicensingClient.getInstance();
export default licensingClient;
